import { gql } from '@apollo/client';

export const DECLINE_TOOL_BOOKING = gql`
  mutation DeclineToolBooking($id: ID!, $message: String) {
    declineToolBooking(input: { id: $id, message: $message }) {
      toolBooking {
        id
        status
        fromDate
        toDate
      }
      errors
    }
  }
`;
